export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-hi-IN.f18ce583.xlsx";